<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapSalesOrders"
        :show-summary="true"
        :summary-columns="summaryColumns"
        :summary-prop="{auth: { totalAmount: limits.priceAuth }}"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select
                  v-model="filter.salesOrderCategory"
                  clearable
                  placeholder="请选择订单类型">
                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="filter.status" clearable placeholder="请选择订单状态">
                <el-option label="草稿" :value="10"/>
                <el-option label="已提交" :value="20"/>
                <el-option label="已通过" :value="25"/>
                <el-option label="未完结" :value="30"/>
                <el-option label="已完结" :value="40"/>
                <el-option label="作废" :value="999"/>
                <el-option label="退单" :value="12"/>
              </el-select>
            </el-form-item>
            <el-form-item label="发货单状态">
              <el-select v-model="filter.deliveryStatus" clearable placeholder="请选择发货单状态">
                <el-option label="未创建" :value="0"/>
                <el-option label="部分创建" :value="10"/>
                <el-option label="全部创建" :value="20"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customer" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="合同编号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>
            </el-form-item>
            <el-form-item label="提交日期">
              <el-date-picker
                  v-model="submitDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitDateRange', 'submitBeginDate', 'submitEndDate')"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :loading="submitLoading"
            :disabled="scope.row.status !== 10 && scope.row.status !== 25"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.creatDeliveryAuth"
            type="primary"
            :disabled="scope.row.status === 10 || scope.row.demandStatus !=='Y'"
            @click="$refs.sapDeliveryEdt.open(scope.row)">
          交货单
        </el-button>
      </template>
      <template slot="otherBtn">
        <el-button v-if="limits.changeAuth" type="primary" :disabled="!selection.length" @click="salesOrderChange">
          销单变更
        </el-button>
        <el-button v-if="limits.subAuth" type="primary" :disabled="!selection.length" @click="submitBatch">
          批量提交
        </el-button>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
    <sap-delivery-edit ref="sapDeliveryEdt"/>
    <sales-order-change ref="salesOrderChange"/>
  </div>
</template>

<script>
  import SalesOrderEdit from "./SalesOrderEdit";
  import loginUtil from "@/util/loginUtil";
  import commonUtil from "@/util/commonUtil.js";
  import ViewTable from "@/components/ViewTable";
  import SapDeliveryEdit from "@/views/SalesManage/DeliveryBll/SapDeliveryEdit";
  import SalesOrderChange from "@/views/SalesManage/SalesOrder/SalesOrderChange";

  export default {
    name: "SalesOrderList",
    components: {SalesOrderChange, SapDeliveryEdit, SalesOrderEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
          subAuth: this.$auth(8),
          creatDeliveryAuth: this.$auth(135),
          changeAuth: this.$auth(702),
          priceAuth:this.$auth(96),
        },
        summaryColumns: ["totalAmount"],
        property: [],
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          customer: "",
          creator: "",
          salesOrderCategory: "",
          customerContractNo: "",
          projectName: "",
          billNo: "",
          status: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
          deliveryStatus: "",
        },
        columnsProperty: [
          {
            key: "salesOrderNO",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.salesOrderNO,
              );
            },
          },
          {
            key: "salesOrderCategoryName",
            width: 160,
            align: "center",
          },
          {
            key: "billNo",
            width: 150,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.salesOrderEdit.open(params.row, 0, true);
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
            key: "customerName",
            width: 260,
            ellipsis: true,
          },
          {
            key: "salesPersonSapNo",
            width: 130,
            align: "center",
          },
          {
            key: "totalAmount",
            width: 110,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                this.limits.priceAuth ? commonUtil.formatNumber(params.row.totalAmount):"***" ,
              );
            },
          },
          {
            key: "customerContractNo",
            width: 250,
            align: "center",
          },
          {
            key: "customerNo",
            width: 150,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "erpSalesOrderNo",
            width: 130,
            align: "center",
          },
          {
            key: "projectName",
            width: 180,
            tooltip: true,
          },
          {
            key: "finalCustomerNo",
            width: 150,
            tooltip: true,
          },
          {
            key: "cascadesName",
            width: 350,
          },
          {
            key: "deliveryDate",
            width: 160,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.deliveryDate ? params.row.deliveryDate.slice(0, 10) : "");
            },
          },
          {
            key: "statusName",
            width: 80,
            align: "center",
          },
          {
            key: "contact",
            align: "center",
            width: 150,
          },
          {
            key: "mobile",
            align: "center",
            width: 150,
          },
          {
            key: "salesDeliveryDate",
            align: "center",
            width: 160,
          },
          {
            key: "demandStatus",
            align: "center",
            width: 160,
          },
          {
            key: "creatorName",
            align: "center",
            width: 80,
          },
          {
            key: "submitDate",
            align: "center",
            width: 160,
          },
          {
            key: "createDate",
            align: "center",
            width: 160,
          },
          {
            key: "clientContractTime",
            align: "center",
            width: 160,
          },
          {
            key: "submitTime",
            align: "center",
            width: 160,
          },
          {
            key: "deliveryStatusName",
            align: "center",
            width: 160,
          },
          {
            key: "clientContractTime",
            align: "center",
            width: 160,
          },
          {
            key: "sourceOrder",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
        options: [],
        submitDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    // created() {
    //   this.getAreaOptions();
    // },
    mounted() {
      this.getSalesOrderCategory();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      getSalesOrderCategory() {
        this.$http.get("basic", "sapSalesOrders/getSalesOrderCategory").then((res) => {
          if (res.success) {
            this.property = res.data;
          }
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 上传文件
      uploadSuccess(fileList, row) {
        if (fileList.length) {
          this.uploadLoading = true;
          const params = {
            itemType: 10,
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: row.salesOrderId,
          };
          this.$http.post("basic", "attachments", params)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
              }
              this.uploadLoading = false;
            })
            .catch(() => {
              this.uploadLoading = false;
            });
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      // 获取所属区域列表
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "sapSalesOrders", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(row) {
        if (row.property === "ZF1" && row.status===10) {//提交OA
          this.$confirm("确定提交到OA吗?", "提示", {type: "warning"}).then(() => {
            this.submitLoading = true;
            this.$http.post("basic", `sapSalesOrders/submitToOa/${row.pkId}`).then((resp) => {
              if (resp.success) {
                this.$message.success("提交OA成功");
                this.loadData();
                this.submitLoading = false;
              }
            }).finally(() => {
              this.submitLoading = false;
            });
          });
        } else {
          let ids = [row.pkId];
          this.$confirm("确定提交到SAP吗?", "提示", {type: "warning"}).then(() => {
            this.submitLoading = true;
            this.$http.post("basic", `sapSalesOrders/submitBatch/${ids}`).then((resp) => {
              if (resp.success) {
                this.$message.success("提交SAP成功");
                this.loadData();
                this.submitLoading = false;
              }
            }).finally(() => {
              this.submitLoading = false;
            });
          });
        }

        this.submitLoading = false;
      },

      submitBatch() {
        let ids = [];
        this.selection.forEach(item=>ids.push(item.pkId));
        this.$confirm("确定提交到SAP吗?", "提示", {type: "warning"}).then(() => {
          this.submitLoading = true;
          this.$http.post("basic", `sapSalesOrders/submitBatch/${ids}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交SAP成功");
              this.loadData();
              this.submitLoading = false;
            }
          }).finally(() => {
            this.submitLoading = false;
          });
        });
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.salesOrderEdit.open(row, 1);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return false;
        } else {
          return true;
        }
      },

      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx" && lastName.toLowerCase() !== ".xls") {
          this.$message.error("请上传.xlsx或.xls文件类型");
        }
      },

      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess(data) {
        if (data.success) {
          this.importLoading = false;
          this.disabled = false;
          this.$message.success("成功导入新的数据");
          this.loadData(1);
        } else {
          this.importLoading = false;
          this.disabled = false;
          this.$message.error(data.message);
        }
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },


      salesOrderChange() {
        if (this.selection.length > 1) {
          this.$message.error("请选择一条数据");
          return;
        }
        this.$refs.salesOrderChange.open(this.selection[0]);
      },
    },
  };
</script>
